<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="users"
      resource="invite_new_users"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->

      <el-table-column
        prop="invite_mobile"
        label="邀请人手机"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />

      <el-table-column
        prop="register_mobile"
        label="注册人手机"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <!-- <el-table-column
        prop="area"
        label="区域"
        align="center"
        show-overflow-tooltip
        min-width="7%"
      >
        <template #default="{ row }">
          <el-tag class="mr-1" v-show="row.quanbu">
            全部
          </el-tag>
          <el-tag
            v-for="i of row.areas"
            :key="i.id"
            class="mr-1"
          >
            {{ i.name }}
          </el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        label="注册人是否实名"
        align="center"
        show-overflow-tooltip
        prop="is_card_certified"
        min-width="4%"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_card_certified"
            type="success"
          >是</el-tag>
          <el-tag
            v-else
            type="danger"
          >否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="注册人是否完成首单"
        align="center"
        prop="is_first_order"
        show-overflow-tooltip
        min-width="4%"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_first_order"
            type="success"
          >是</el-tag>
          <el-tag
            v-else
            type="danger"
          >否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="名额是否有效"
        align="center"
        show-overflow-tooltip
        min-width="4%"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >有效</el-tag>
          <el-tag
            v-else
            type="danger"
          >无效</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <!-- <el-table-column
        prop="updated_at"
        label="修改时间"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <el-table-column
        label="操作"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit/>
            <row-destroy/>
          </el-button-group>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getInviteNewUsers } from "@/api/invite-new-users-configs";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        // {
        //   field: 'id',
        //   label: 'ID',
        // },
        {
          type: "super-input",
          field: "invite_mobile_nickname",
          label: "邀请人手机号"
        },
        {
          type: "super-input",
          field: "register_mobile_nickname",
          label: "注册人手机号"
        },
        {
          type: "el-select",
          field: "status",
          label: "名额是否有效",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "无效"
            },
            {
              id: 1,
              name: "有效"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_card_certified",
          label: "是否实名",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "未实名"
            },
            {
              id: 1,
              name: "已实名"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_first_order",
          label: "是否完成首单",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "未完成"
            },
            {
              id: 1,
              name: "已完成"
            }
          ]
        }
      ],
      users: [],
      page: null,
      first_blood: true
    };
  },
  mixins: [mixinsAutoPageSize],
  async created() {
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[5].options.push.apply(
          this.search[5].options,
          merchant.data
        );
      }
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getInviteNewUsers(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
